// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"fNKrn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initComponentsPage", ()=>initComponentsPage);
var _componentHandler = require("../../utils/componentHandler");
var _handler = require("./handler");
var _auth = require("../auth");
const initComponentsPage = ()=>{
    // Initialize component handler for copy functionality
    new (0, _handler.ComponentHandler)();
    const isLoggedIn = (0, _auth.userAuth).getRole() === "USER";
    if (!isLoggedIn) {
        console.log("User is not logged in, redirecting to login page");
        return;
    }
    new (0, _componentHandler.ComponentCardHandler)();
};

},{"../../utils/componentHandler":"1tOWX","./handler":"lUaz0","../auth":"apxUl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1tOWX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponentCardHandler", ()=>ComponentCardHandler);
var _core = require("@xatom/core");
var _favorites = require("../services/api/favorites");
var _favoritesStore = require("../stores/favoritesStore");
class ComponentCardHandler {
    constructor(){
        this.init();
        this.observeDOMChanges();
    }
    async init() {
        try {
            const response = await (0, _favorites.FavoritesAPI).getFavorites();
            const favoriteComponents = response.data.favorite_components || {};
            (0, _favoritesStore.favoritesStore).setFavorites({
                favorite_components: favoriteComponents,
                favorite_inspirations: {}
            });
            const componentCards = document.querySelectorAll('[ss-component-ele="card"]');
            componentCards.forEach((cardElement)=>{
                this.setupCard(cardElement);
            });
        } catch (error) {
            console.error("Error fetching favorites:", error);
        }
    }
    setupCard(cardElement) {
        const $card = new (0, _core.WFComponent)(cardElement);
        const $favBtn = $card.getChildAsComponent('[fav-btn-class="is-fav"]');
        const slug = $card.getAttribute("ss-webflow-component");
        const favorites = (0, _favoritesStore.favoritesStore).getFavoriteComponents();
        if (favorites[slug]) $favBtn.addCssClass("is-fav");
        if ($favBtn && !$favBtn.getElement().hasAttribute("data-listener-added")) {
            $favBtn.getElement().setAttribute("data-listener-added", "true");
            $favBtn.on("click", async ()=>{
                try {
                    const isFavorite = $favBtn.getCssClass().includes("is-fav");
                    if (!slug) {
                        console.error("Slug not found");
                        return;
                    }
                    const toggleResponse = await (0, _favorites.FavoritesAPI).toggleFavorite({
                        slug,
                        type: "component",
                        isFavorite: !isFavorite
                    });
                    if (toggleResponse.data.success) {
                        if (toggleResponse.data.favorites[slug]) {
                            $favBtn.addCssClass("is-fav");
                            (0, _favoritesStore.favoritesStore).updateFavorite("component", slug, toggleResponse.data.favorites[slug]);
                        } else {
                            $favBtn.removeCssClass("is-fav");
                            (0, _favoritesStore.favoritesStore).updateFavorite("component", slug, null);
                        }
                    } else console.error("Failed to toggle favorite");
                } catch (error) {
                    console.error("Error toggling favorite:", error);
                }
            });
        }
    }
    observeDOMChanges() {
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.type === "childList" && mutation.addedNodes.length > 0) mutation.addedNodes.forEach((node)=>{
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const cardElement = node;
                        if (cardElement.matches('[ss-component-ele="card"]') || cardElement.querySelector('[ss-component-ele="card"]')) {
                            const cardElementIn = cardElement.matches('[ss-component-ele="card"]') ? cardElement : cardElement.querySelector('[ss-component-ele="card"]');
                            this.setupCard(cardElementIn);
                        }
                    }
                });
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
}

},{"@xatom/core":"5eqAK","../services/api/favorites":"3qAOR","../stores/favoritesStore":"4AfNp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lUaz0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponentHandler", ()=>ComponentHandler);
var _core = require("@xatom/core");
var _auth = require("../../services/api/auth");
var _supbase = require("../supbase");
var _supbaseDefault = parcelHelpers.interopDefault(_supbase);
var _config = require("../../config");
class ComponentHandler {
    constructor(){
        this.componentElesList = [];
        if (this.hasFinsweetLoadMoreAdded()) this.loadAndUpdateComponent();
        else this.init();
    }
    loadAndUpdateComponent() {
        window.fsAttributes = window.fsAttributes || [];
        window.fsAttributes.push([
            "cmsload",
            (listInstances)=>{
                // The callback passes a `listInstances` array with all the `CMSList` instances on the page.
                const [listInstance] = listInstances;
                this.componentElesList = listInstance.items.map((item)=>{
                    return item.element;
                });
                this.init();
            }
        ]);
    }
    hasFinsweetLoadMoreAdded() {
        const finsweetLoadMore = document.querySelector(`[fs-cmsfilter-element="list"] [ss-component-ele="card"]`);
        if (finsweetLoadMore) return true;
        return false;
    }
    init() {
        if (!this.componentElesList || this.componentElesList.length === 0) this.components = Array.from(document.querySelectorAll("[ss-webflow-component]")).map((el)=>new (0, _core.WFComponent)(el));
        else this.components = Array.from(this.componentElesList).map((el)=>{
            const $comp = el.querySelector("[ss-webflow-component]");
            return new (0, _core.WFComponent)($comp);
        });
        this.initButtons();
    }
    async checkAuth() {
        const { data } = await (0, _supbaseDefault.default).auth.getSession();
        return !!data.session;
    }
    async getComponentCode(slug) {
        try {
            const response = await (0, _auth.AuthAPI).getComponent(slug);
            if (response.status === 200) {
                const componentCode = response.data.componentJson;
                return componentCode;
            }
            throw new Error("Failed to fetch component");
        } catch (error) {
            console.error("Error fetching component:", error);
            throw error;
        }
    }
    async copyToClipboard(text, type = "application/json") {
        try {
            await navigator.clipboard.writeText(text);
            const copyJson = (e)=>{
                e.preventDefault();
                if (e.clipboardData) e.clipboardData.setData(type, text);
                else console.error("ClipboardData is not available");
            };
            document.addEventListener("copy", copyJson);
            document.execCommand("Copy");
            document.removeEventListener("copy", copyJson);
        } catch (err) {
            console.error("Failed to copy using clipboard API:", err);
            // Fallback for older browsers
            const copyJson = (e)=>{
                e.preventDefault();
                if (e.clipboardData) e.clipboardData.setData(type, text);
                else console.error("ClipboardData is not available");
            };
            document.addEventListener("copy", copyJson);
            document.execCommand("Copy");
            document.removeEventListener("copy", copyJson);
        }
    }
    initButtons() {
        this.components.forEach((component)=>{
            const copyBtn = component.getChildAsComponent('[ss-webflow-component-ele="copy-btn"]');
            const previewBtn = component.getChildAsComponent('[ss-webflow-component-ele="preview-comp-btn"]');
            const favBtn = component.getChildAsComponent('[ss-webflow-component-ele="fav-comp-btn"]');
            if (copyBtn) this.initCopyButton(copyBtn, component);
            if (previewBtn) this.initPreviewButton(previewBtn, component);
            if (favBtn) this.initFavButton(favBtn);
        });
    }
    initCopyButton(copyBtn, component) {
        const copyBtnPara = copyBtn.getChildAsComponent("p");
        const originalText = copyBtnPara.getText();
        copyBtn.on("click", async ()=>{
            // Check if user is logged in
            const isLoggedIn = await this.checkAuth();
            if (!isLoggedIn) {
                (0, _core.navigate)((0, _config.websiteRoutes).signup);
                return;
            }
            const slug = component.getAttribute("ss-webflow-component");
            const type = "application/json";
            if (!slug) {
                console.error("No component slug provided");
                return;
            }
            try {
                // Show loading state
                copyBtnPara.setText("Copying...");
                copyBtn.setAttribute("disabled", "true");
                // Get and copy component code
                const code = await this.getComponentCode(slug);
                await this.copyToClipboard(code, type);
                // Show success state
                copyBtnPara.setText("Copied!");
                // Reset button after 2 seconds
                setTimeout(()=>{
                    copyBtnPara.setText(originalText);
                    copyBtn.removeAttribute("disabled");
                }, 2000);
            } catch (error) {
                console.error("Failed to copy:", error);
                copyBtnPara.setText("Failed to copy");
                setTimeout(()=>{
                    copyBtnPara.setText(originalText);
                    copyBtn.removeAttribute("disabled");
                }, 2000);
            }
        });
    }
    initPreviewButton(previewBtn, component) {
        previewBtn.on("click", ()=>{
            const componentId = component.getAttribute("preview-comp-link");
            if (componentId) window.open(`${(0, _config.websiteRoutes).preview}?comp_id=${componentId}`, "_blank");
            else console.error("No component ID provided");
        });
    }
    initFavButton(favBtn) {
        favBtn.on("click", ()=>{
            console.log("Favorite button clicked");
        });
    }
}

},{"@xatom/core":"5eqAK","../../services/api/auth":"7lOrd","../supbase":"54PYi","../../config":"dwh13","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7lOrd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthAPI", ()=>AuthAPI);
var _interceptors = require("../axios/interceptors");
var _interceptorsDefault = parcelHelpers.interopDefault(_interceptors);
const AuthAPI = {
    verifyToken: ()=>{
        return (0, _interceptorsDefault.default).post("/auth/verify");
    },
    getUserProfile: ()=>{
        return (0, _interceptorsDefault.default).get("/auth/profile");
    },
    getComponent: (componentSlug)=>{
        return (0, _interceptorsDefault.default).get(`/api/component/${componentSlug}`);
    },
    previewComponent: ()=>{
        return (0, _interceptorsDefault.default).get(`/preview/hero-header-sections/section_header27`);
    }
};

},{"../axios/interceptors":"8hA85","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9hlB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API_CONFIG", ()=>API_CONFIG);
const API_CONFIG = {
    baseURL: "https://api.shaiksaif.com"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=component.39fe6bf2.js.map
